import { Controller } from "@hotwired/stimulus"

// Keeps the builder's live preview in step: reloads the preview iframe after
// any successful save on the page, keeping the visitor's scroll position.
export default class extends Controller {
  static targets = ["frame"]

  refresh(event) {
    if (!event.detail.success) return

    const frame = this.frameTarget
    const scrollY = frame.contentWindow?.scrollY || 0
    frame.addEventListener("load", () => frame.contentWindow?.scrollTo(0, scrollY), { once: true })
    frame.contentWindow?.location.reload()
  }
}
